import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=4f1fd016&scoped=true"
import script from "./Connections.vue?vue&type=script&lang=ts"
export * from "./Connections.vue?vue&type=script&lang=ts"
import style0 from "./Connections.vue?vue&type=style&index=0&id=4f1fd016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1fd016",
  null
  
)

export default component.exports